<mat-icon [style.color]="color"
          [style.fontSize]="sizeOrDefault"
          [attr.data-iconId]="iconId"
          class="cipo-text--black"
          aria-hidden="true">
    {{ name }}
</mat-icon>